class elementsAll {
  constructor(
    id,
    element,
    from,
    to,
    tolEnt,
    tolSal,
    conceptId,
    laboral,
    aplFeriados,
    aplNoFeriados,
    mts,
    fracRed,
    porcen,
    resto,
  ) {
    this.id = id;
    this.name = element;
    this.from = from;
    this.to = to;
    this.tolEnt = tolEnt;
    this.tolSal = tolSal;
    this.conceptId = conceptId;
    this.laboral = laboral;
    this.aplFeriados = aplFeriados;
    this.aplNoFeriados = aplNoFeriados;
    this.mts = mts;
    this.fracRed = fracRed;
    this.porcen = porcen;
    this.resto = resto;
  }
  static fromJson({
    elemId,
    nombre,
    desde,
    hasta,
    tolEnt,
    tolSal,
    conceptoId,
    laboral,
    aplFeriados,
    aplNoFeriados,
    mts,
    fracRed,
    porcen,
    resto,
  }) {
    return new elementsAll(
      elemId,
      nombre,
      desde,
      hasta,
      tolEnt,
      tolSal,
      conceptoId,
      laboral,
      aplFeriados,
      aplNoFeriados,
      mts,
      fracRed,
      porcen,
      resto,
    );
  }
}
export default elementsAll;
